import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import './Home.css';
import { FaBolt, FaUsers, FaArrowRight } from 'react-icons/fa';
import { HomeSVG, playSound } from '../../utils/utils';
import LoadSavedGames from '../../components/LoadSavedGames/LoadSavedGames';
import WarpLink from '../../components/WarpTransition/WarpLink';

const Home = (props) => {
  const { setPlayerNamesState } = props;

  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleGlobalError = () => {
      history.push('/');
    };

    window.addEventListener('error', handleGlobalError);

    return () => {
      window.removeEventListener('error', handleGlobalError);
    };
  }, [history]);

  const handleSinglePlayerClick = () => {
    playSound('/sounds/entering_single_player_game.mp3');
  };

  const handleMultiPlayerClick = () => {
    playSound('/sounds/menu-select.mp3');
  };

  return (
    <header className="App-header">
      <div className="homeTitle">
        <div className="homeTitle__aura" aria-hidden="true">
          {Array.from({ length: 9 }, (_, index) => (
            <span
              key={index}
              style={{
                '--aura-position': `${10 + index * 10}%`,
                '--aura-delay': `${index * -0.37}s`,
                '--aura-height': `${70 + (index % 3) * 24}%`,
              }}
            />
          ))}
        </div>
        <div className="homeTitle__sparks" aria-hidden="true">
          {Array.from({ length: 12 }, (_, index) => (
            <span
              key={index}
              style={{
                '--spark-position': `${5 + index * 8}%`,
                '--spark-delay': `${index * -0.31}s`,
              }}
            />
          ))}
        </div>
        <h1 className="homeTitle__text">
          SLASH <span>ROLL</span>
        </h1>
        <svg
          className="homeTitle__lightning"
          viewBox="0 0 500 110"
          aria-hidden="true"
        >
          <path d="M5 70 58 58 43 80 116 64 104 85 163 77 M340 76 395 59 382 82 456 61 439 84 497 71" />
          <path d="M58 58 73 34 90 38 109 14 M395 59 414 33 429 38 451 10" />
        </svg>
      </div>
      <HomeSVG />
      <div className="Home">
        <div className="gameSelection">
          <div className="modeButtonStage modeButtonStageSolo">
            <div className="soloFlameField" aria-hidden="true">
              {Array.from({ length: 28 }, (_, index) => {
                const side = Math.floor(index / 7);
                const position = `${12 + (index % 7) * 12.6}%`;
                return (
                  <span
                    key={index}
                    style={{
                      '--flame-x':
                        side === 1 ? '100%' : side === 3 ? '0%' : position,
                      '--flame-y':
                        side === 0 ? '0%' : side === 2 ? '100%' : position,
                      '--flame-angle': `${side * 90}deg`,
                      '--flame-height': `${24 + (index % 3) * 9}px`,
                      '--flame-delay': `${index * -0.19}s`,
                      '--flame-speed': `${1.4 + (index % 4) * 0.2}s`,
                    }}
                  />
                );
              })}
            </div>
            <WarpLink
              className="homeMode homeMode--solo"
              aria-label="Single player"
              to="/single-player"
              label="SOLO CHANNEL OPENING"
              variant="portal"
              onClick={handleSinglePlayerClick}
            >
              <span className="homeMode__topline">
                <span>01 / SOLO CHANNEL</span>
                <span className="homeMode__online" />
              </span>
              <span className="homeMode__emblem" aria-hidden="true">
                <FaBolt />
              </span>
              <span className="homeMode__title">SINGLE PLAYER</span>
              <span className="homeMode__description">
                One player. Infinite possibilities.
              </span>
              <span className="homeMode__launch">
                ENTER SOLO <FaArrowRight aria-hidden="true" />
              </span>
            </WarpLink>
          </div>
          <div className="modeButtonStage modeButtonStageMulti">
            <svg
              className="multiElectricField"
              viewBox="0 0 360 260"
              preserveAspectRatio="none"
              aria-hidden="true"
              focusable="false"
            >
              <rect
                className="multiElectricRail"
                x="1"
                y="1"
                width="358"
                height="258"
                rx="16"
              />
              <path
                className="multiElectricArc multiElectricArcOne"
                pathLength="100"
                d="M16 1 40 1 49 -4 57 4 66 0 103 1 113 -5 120 4 133 1 175 1 187 -4 196 4 207 1 249 1 263 -5 270 4 283 1 344 1Q359 1 359 16L359 53 364 63 355 71 360 81 359 119 365 130 355 141 359 153 359 193 364 204 356 217 359 229 359 244"
              />
              <path
                className="multiElectricArc multiElectricArcTwo"
                pathLength="100"
                d="M344 259 312 259 301 265 293 255 282 260 240 259 226 264 218 255 208 259 163 259 151 265 141 255 132 259 83 259 74 264 66 255 55 259 16 259Q1 259 1 244L1 210 -5 200 5 192 0 179 1 142 -4 132 5 123 1 111 1 74 -5 63 5 54 1 41 1 16"
              />
              <path
                className="multiElectricArc multiElectricArcThree"
                pathLength="100"
                d="M1 28V16Q1 1 16 1H60 M302 1H344Q359 1 359 16V40 M359 215V244Q359 259 344 259H308 M55 259H16Q1 259 1 244V222"
              />
              <path
                className="multiElectricBranch"
                d="M113 0 119 -10 114 -16 M359 130 370 137 376 131 M226 260 233 271 225 278 M0 132 -11 127 -17 134"
              />
            </svg>
            <WarpLink
              className="homeMode homeMode--multi"
              aria-label="Multiplayer"
              to="/multi/select-player-count"
              label="PARTY LINK ESTABLISHED"
              variant="roll"
              onClick={handleMultiPlayerClick}
            >
              <span className="homeMode__topline">
                <span>02 / PARTY CHANNEL</span>
                <span className="homeMode__online" />
              </span>
              <span className="homeMode__emblem" aria-hidden="true">
                <FaUsers />
              </span>
              <span className="homeMode__title">MULTIPLAYER</span>
              <span className="homeMode__description">
                Bring your rivals. Claim the crown.
              </span>
              <span className="homeMode__launch">
                ASSEMBLE CREW <FaArrowRight aria-hidden="true" />
              </span>
            </WarpLink>
          </div>
        </div>

        <div className="homeOptions">
          <LoadSavedGames setPlayerNamesState={setPlayerNamesState} />
          <code className="createdBy">Created by: Mark Bernstein</code>
        </div>
      </div>
    </header>
  );
};

export default Home;
